// Apagados — tudo o que está marcado como apagado, só para a líder (aprovado pela Sónia a 30/10/2026).
// Recuperar volta a pôr ativo. Apagar definitivamente usa a função da base de dados apagar_definitivo
// (só a líder, só o que já está marcado como apagado, bloqueia negócios com recebimentos, fica registado).
// A app nunca apaga nada sozinha: só quando a líder carrega no botão e escreve APAGAR.
import React, { useEffect, useState } from "react";
import { ds, Codigo, Etiqueta } from "./desenho";

const TIPOS = [
  { k: "negocios", nome: "Negócios", sel: "id, codigo, imovel_ref, imovel_morada, consultor_ang_nome, deleted_at, proposta_id, cpcv_id" },
  { k: "propostas", nome: "Propostas", sel: "id, codigo, imovel_ref, imovel_morada, consultor_ang_nome, deleted_at, negocio_id" },
  { k: "formularios_cpcv", nome: "CPCV", sel: "id, codigo, ref_imovel, agente_nome, deleted_at, negocio_id" },
  { k: "leads", nome: "Contactos", sel: "id, codigo, nome, consultor_nome, deleted_at" },
  { k: "angariações", nome: "Angariações", sel: "id, codigo, id_angariacao, morada, consultor_nome, deleted_at" },
];
const dataPT = (d) => (d ? new Date(d).toLocaleDateString("pt-PT") : "—");
const titulo = (t, r) => (t === "leads" ? r.nome : r.imovel_ref || r.ref_imovel || r.id_angariacao || "Sem ID");
const quem = (r) => r.consultor_ang_nome || r.agente_nome || r.consultor_nome || "—";

export default function Apagados({ supabase, isLider, onAlterado }) {
  const [tipo, setTipo] = useState("negocios");
  const [listas, setListas] = useState({});
  const [aCarregar, setACarregar] = useState(true);
  const [janela, setJanela] = useState(null); // { t, r, resumo, texto, erro, aApagar }
  const [aviso, setAviso] = useState("");

  const carregar = async () => {
    setACarregar(true);
    const res = {};
    for (const t of TIPOS) {
      const { data } = await supabase.from(t.k).select(t.sel).not("deleted_at", "is", null).order("deleted_at", { ascending: false });
      res[t.k] = data || [];
    }
    setListas(res); setACarregar(false);
  };
  useEffect(() => { if (isLider) carregar(); }, [isLider]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isLider) return <div style={{ padding: 32, color: ds.tinta3 }}>Só a líder tem acesso aos registos apagados.</div>;

  const recuperar = async (t, r) => {
    const { error } = await supabase.from(t).update({ deleted_at: null }).eq("id", r.id);
    if (!error && t === "negocios") { // o negócio volta com a sua proposta e o seu CPCV
      if (r.proposta_id) await supabase.from("propostas").update({ deleted_at: null }).eq("id", r.proposta_id);
      if (r.cpcv_id) await supabase.from("formularios_cpcv").update({ deleted_at: null }).eq("id", r.cpcv_id);
    }
    setAviso(error ? "Não foi possível recuperar: " + error.message : `${r.codigo || titulo(t, r)} recuperado.`);
    await carregar(); onAlterado && onAlterado();
  };

  const abrirApagar = async (t, r) => {
    setJanela({ t, r, resumo: null, texto: "", erro: "" });
    const { data, error } = await supabase.rpc("apagar_definitivo_resumo", { p_tabela: t, p_id: String(r.id) });
    setJanela((j) => j && { ...j, resumo: data, erro: error ? error.message : "" });
  };
  const apagar = async () => {
    setJanela((j) => ({ ...j, aApagar: true, erro: "" }));
    const { error } = await supabase.rpc("apagar_definitivo", { p_tabela: janela.t, p_id: String(janela.r.id) });
    if (error) { setJanela((j) => ({ ...j, aApagar: false, erro: error.message })); return; }
    setAviso(`${janela.r.codigo || titulo(janela.t, janela.r)} apagado definitivamente.`);
    setJanela(null); await carregar(); onAlterado && onAlterado();
  };

  const lista = listas[tipo] || [];
  const bt = { border: `1.5px solid ${ds.linha}`, borderRadius: 8, padding: "5px 10px", fontSize: 13, background: "#fff", color: ds.tinta2, cursor: "pointer", fontFamily: "inherit" };
  const btPerigo = { ...bt, borderColor: ds.falta, color: ds.falta, fontWeight: 700 };
  const r = janela?.resumo;
  const bloqueado = !!r && ((janela?.t === "negocios" && (r.recebimentos > 0 || [...(r.propostas || []), ...(r.cpcv || [])].some((x) => !x.apagado)))
    || r.em_processos > 0 || !!r.negocio_ativo); // contacto/angariação ligados a processos, ou proposta de um negócio ativo

  return (
    <div style={{ padding: "24px 0 48px", display: "grid", gap: 14, color: ds.tinta, fontFamily: ds.letra }}>
      <div>
        <h1 style={{ fontFamily: ds.titulo, fontSize: 26, margin: 0, color: ds.navy9 }}>Apagados</h1>
        <p style={{ margin: "4px 0 0", fontSize: 13, color: ds.tinta3 }}>Tudo o que está marcado como apagado. Só a líder vê esta página. Recuperar volta a pôr ativo; apagar definitivamente não tem volta.</p>
      </div>
      {aviso && <div role="status" style={{ background: ds.okFundo, color: ds.ok, borderRadius: 10, padding: "8px 12px", fontSize: 13, fontWeight: 600 }}>{aviso}</div>}
      <div role="tablist" style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {TIPOS.map((t) => (
          <button key={t.k} role="tab" aria-selected={tipo === t.k} onClick={() => setTipo(t.k)}
            style={{ ...bt, ...(tipo === t.k ? { borderColor: ds.navy7, color: ds.navy9, background: ds.navy0, fontWeight: 700 } : {}) }}>
            {t.nome} <b>{(listas[t.k] || []).length}</b>
          </button>
        ))}
      </div>
      <div style={{ background: "#fff", border: `1px solid ${ds.linha}`, borderRadius: 14, overflow: "hidden" }}>
        {aCarregar ? <div style={{ padding: 20, color: ds.tinta3 }}>A carregar…</div> : !lista.length ? <div style={{ padding: 20, color: ds.tinta3 }}>Não há {TIPOS.find((t) => t.k === tipo).nome.toLowerCase()} apagados.</div> : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13.5 }}>
              <thead><tr style={{ background: ds.navy9, color: "#fff", textAlign: "left" }}>
                {["Código", tipo === "leads" ? "Nome" : "ID do imóvel", "Consultor", "Apagado em", ""].map((h) => <th key={h} style={{ padding: "9px 12px", fontSize: 11, letterSpacing: ".06em", textTransform: "uppercase" }}>{h}</th>)}
              </tr></thead>
              <tbody>{lista.map((x) => (
                <tr key={x.id} style={{ borderTop: `1px solid ${ds.linha}` }}>
                  <td style={{ padding: "9px 12px" }}>{x.codigo ? <Codigo valor={x.codigo} /> : <span style={{ color: ds.tinta3 }}>—</span>}</td>
                  <td style={{ padding: "9px 12px" }}><b>{titulo(tipo, x)}</b>{(x.imovel_morada || x.morada) && <div style={{ fontSize: 12, color: ds.tinta3 }}>{x.imovel_morada || x.morada}</div>}</td>
                  <td style={{ padding: "9px 12px" }}>{quem(x)}</td>
                  <td style={{ padding: "9px 12px", whiteSpace: "nowrap" }}>{dataPT(x.deleted_at)}</td>
                  <td style={{ padding: "9px 12px", textAlign: "right", whiteSpace: "nowrap" }}>
                    <button style={bt} onClick={() => recuperar(tipo, x)}>↩ Recuperar</button>{" "}
                    <button style={btPerigo} aria-label={`Apagar definitivamente ${x.codigo || titulo(tipo, x)}`} onClick={() => abrirApagar(tipo, x)}>Apagar definitivamente</button>
                  </td>
                </tr>))}
              </tbody>
            </table>
          </div>)}
      </div>

      {janela && (
        <div role="dialog" aria-modal="true" aria-label="Apagar definitivamente" style={{ position: "fixed", inset: 0, background: "rgba(10,18,40,.45)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={() => !janela.aApagar && setJanela(null)}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 20, width: 460, maxWidth: "100%", display: "grid", gap: 12, fontFamily: ds.letra }}>
            <b style={{ fontSize: 16, color: ds.falta }}>Apagar definitivamente {janela.r.codigo || titulo(janela.t, janela.r)}?</b>
            <p style={{ margin: 0, fontSize: 13, color: ds.tinta2 }}>Isto não tem volta. Sai da base de dados:</p>
            {!r && !janela.erro && <span style={{ fontSize: 13, color: ds.tinta3 }}>A verificar o que sai…</span>}
            {r && janela.t === "negocios" && (
              <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, display: "grid", gap: 3 }}>
                <li>Negócio {r.negocio?.codigo} · {r.negocio?.ref}</li>
                {(r.propostas || []).map((p) => <li key={p.codigo}>Proposta {p.codigo} {!p.apagado && <Etiqueta tom="falta">ainda ativa</Etiqueta>}</li>)}
                {(r.cpcv || []).map((c) => <li key={c.codigo}>CPCV {c.codigo} {!c.apagado && <Etiqueta tom="falta">ainda ativo</Etiqueta>}</li>)}
                {r.comissoes > 0 && <li>{r.comissoes} comissão(ões) deste negócio</li>}
                {r.satisfacao > 0 && <li>{r.satisfacao} formulário(s) de satisfação</li>}
                {r.recebimentos > 0 && <li><Etiqueta tom="falta">Bloqueado</Etiqueta> tem {r.recebimentos} recebimento(s) registado(s)</li>}
              </ul>)}
            {r && janela.t !== "negocios" && <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}><li>{{ propostas: "Proposta", formularios_cpcv: "CPCV", leads: "Contacto", "angariações": "Angariação" }[janela.t]} {r.codigo} · {r.ref || r.nome}</li>
              {r.negocio_ativo && <li><Etiqueta tom="falta">Bloqueado</Etiqueta> pertence a um negócio ativo</li>}
              {r.em_processos > 0 && <li><Etiqueta tom="falta">Bloqueado</Etiqueta> está ligado a {r.em_processos} {janela.t === "angariações" ? "proposta(s), negócio(s), visita(s) ou financiamento(s)" : "proposta(s)/negócio(s)"}</li>}</ul>}
            {!["leads", "angariações"].includes(janela.t) && <p style={{ margin: 0, fontSize: 12.5, color: ds.ok, fontWeight: 600 }}>✓ Os contactos (clientes) e a angariação deste processo não são apagados.</p>}
            {bloqueado && <p style={{ margin: 0, fontSize: 13, color: ds.falta, fontWeight: 600 }}>Não é possível apagar enquanto houver recebimentos, partes ainda ativas ou processos ligados.</p>}
            <label style={{ display: "grid", gap: 4, fontSize: 13, fontWeight: 600, color: ds.tinta2 }}>Para confirmar, escreva APAGAR
              <input value={janela.texto} onChange={(e) => setJanela((j) => ({ ...j, texto: e.target.value }))} autoFocus disabled={bloqueado}
                style={{ border: `1.5px solid ${ds.linha}`, borderRadius: 8, padding: "7px 10px", font: "inherit" }} /></label>
            {janela.erro && <div role="alert" style={{ color: ds.falta, fontSize: 13, fontWeight: 600 }}>⚠ {janela.erro}</div>}
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button style={bt} onClick={() => setJanela(null)} disabled={janela.aApagar}>Cancelar</button>
              <button style={{ ...btPerigo, background: janela.texto.trim().toUpperCase() === "APAGAR" && !bloqueado ? ds.falta : "#fff", color: janela.texto.trim().toUpperCase() === "APAGAR" && !bloqueado ? "#fff" : ds.falta }}
                disabled={janela.texto.trim().toUpperCase() !== "APAGAR" || bloqueado || janela.aApagar || !r} onClick={apagar}>{janela.aApagar ? "A apagar…" : "Apagar definitivamente"}</button>
            </div>
          </div>
        </div>)}
    </div>
  );
}
